import { selectIsIEnvision } from 'App/redux/appSlice';
import { useSelector } from './redux';

const useIEnvision = () => useSelector(selectIsIEnvision);

export default useIEnvision;
